export enum FreeEvaluationType{
    MidYear, EndYear
}